import React from 'react';
import PathSection from "../traid-components/PathSection";
import Targets from "../traid-components/Targets";
import Audience from "../traid-components/Audience";
import BackgroundGrid from "../base-components/BackgroundGrid";

function Traid() {
    return (
        <main>
            <PathSection />
            <section className="relative overflow-hidden bg-dark">
                <BackgroundGrid
                    gridSize="50px"
                    gridColor="#10B981"
                    opacity={0.3}
                    fadeOffset={0.3}
                />
                <div className="relative z-10">
                    <Targets />
                    <Audience />
                </div>
                <div className="flex flex-row justify-center text-center mx-2 my-8">
                    <p className="text-xs md:text-sm lg:text-base 2xl:text-xl opacity-70 mt-2 text-white">Traid fornisce strumenti informativi e analitici. Nessuna raccomandazione d'investimento o attività di intermediazione finanziaria.</p>
                </div>
            </section>
        </main>
    );
}

export default Traid;
